import { getCookie, deleteCookie, setCookie } from "../utils/cookie";
import { refresh_token, user_init } from "./endpoints";
import { permissions } from "./permissions";
import { loginRequest } from "./../components/activeDirectory/msalConfig";


const getActiveDirectoryToken = async (instance, accounts) => {
  let session = null;
  
  try {
    session = instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {        
        if (response)
          return JSON.stringify({
            token: response.accessToken,
            refreshToken: null,
          });
        return null;
      });
  } catch (error) {
    console.error("Errore durante l'acquisizione del token:", error);
  }
  return session;
};

export const checkSession = async (
  updateContext,
  navigateUrl,
  requestFetch,
  instanceActiveDirectory,
  accountsActiveDirectory
) => {  

  let session = null;
  let is_active_directory = false;
  const isAuthenticatedWithAD = getCookie("is_active_directory") === "true";
  if (accountsActiveDirectory && accountsActiveDirectory.length > 0) {  
    session = await getActiveDirectoryToken(
      instanceActiveDirectory,
      accountsActiveDirectory
    );
    is_active_directory = true;
  } 
  else
  {      
   session = getCookie("session_cookie");
  }
  const current_path =
    permissions.find((x) => x.href === window.location.pathname) ||
    permissions.find((x) => x.is_index);

  let is_white_list_url =
    current_path.permission.includes("ALL") &&
    current_path.redirect_session === null;

  !current_path.permission.includes("ALL") && current_path.need_session;

  let is_frame_parent = current_path.is_frame_parent;


  if (session) {
    
    session = JSON.parse(session);
    let response = await requestFetch(
      "get",
      user_init,
      null,
      session.token,
      true
    );
    if (response.result) {
      is_white_list_url =
        !current_path.permission.includes("ALL") &&
        current_path.permission.includes(response.data.profileTypeCode);
      const current_session = {
        session: { ...response.data, ...session },
        is_active_directory: is_active_directory,
      };
      updateContext(current_session);

      // if (current_session?.session && !current_session.session.privacyConsent)
      //   context.openModal(<PrivacyConsentUser context={context} />);

      if (!is_white_list_url) {
        navigateUrl("/");
      }
    } else {
      refreshToken(
        session,
        updateContext,
        navigateUrl,
        requestFetch,
        is_white_list_url,
        is_frame_parent,
        is_active_directory
      );
    }
  } else if (!is_white_list_url) {
    if (!is_frame_parent ) {
      if (!isAuthenticatedWithAD){
        navigateUrl("/login");
      }      
    } else window.parent.postMessage({ session_expired: true }, "*");
  }
};

const refreshToken = async (
  session,
  updateContext,
  navigateUrl,
  requestFetch,
  is_white_list_url,
  is_frame_parent,
  is_active_directory
) => {
  let refresh_response;
  if (getCookie("remember_session")) {
    refresh_response = !is_active_directory
      ? await requestFetch(
          "get",
          refresh_token,
          null,
          session.refreshToken,
          true
        )
      : null;
  }

  if (!!refresh_response && refresh_response?.result) {
    setCookie(
      "session_cookie",
      JSON.stringify({
        token: refresh_response.data.token,
        refreshToken: session.refreshToken,
      })
    );
    let response = await requestFetch(
      "get",
      user_init,
      null,
      refresh_response.data.token,
      true
    );

    if (response.result) {
      updateContext({
        session: {
          ...response.data,
          ...refresh_response.data,
          refreshToken: session.refreshToken,
        },
      });
    } else if (!is_white_list_url) {
      if (!is_frame_parent) navigateUrl("/login");
      else window.parent.postMessage({ session_expired: true }, "*");
    }
  } else {
    localStorage.removeItem("last_container_viewed");
    deleteCookie("session_cookie");
    deleteCookie("pv_impersonate");
    deleteCookie("remember_session");
    updateContext({ session: null, is_active_directory: false });
    if (!is_white_list_url) {
      if (!is_frame_parent) navigateUrl("/login");
      else window.parent.postMessage({ session_expired: true }, "*");
    }
  }
};
